import { IOrganizationDetails } from '@forwardflow/types/organization'
import { apiDelete, apiGet, apiPatch, apiPost } from '../Axios/configs'
import { ResponseSuccess } from '@forwardflow/types'

type IOnboardingProgress = {
   progress: number
   id: string
   key: string
   value: string
   options: {
      isRequired: boolean
   }
}

export type IProgressData = {
   total: number
   pulled: number
   progress: number
}

export type IOnboardingProgressData = {
   completedSteps: []
   people: {
      next: null
   }
   onboardingProgress: {
      a2pRegistration: {
         status: 'completed' | 'in_complete' | 'in_progress' | 'failed'
         meta: {
            ein: string
            legal_business_name: string
         }
         percentage: number
      }
      businessHours: {
         status: 'completed' | 'in_complete' | 'in_progress' | 'failed'
         meta: null
         percentage: null
      }
      inviteAgents: {
         status: 'completed' | 'in_complete' | 'in_progress' | 'failed'
         meta: null
         percentage: null
      }

      subscriptionActivated: {
         status: 'completed'
         meta: null
         percentage: null
      }
      stageMappings: {
         status: 'completed' | 'in_complete' | 'in_progress' | 'failed'
         meta: null
         percentage: null
      }
   }
   businessDetails: {
      ein: string
      legalBusinessName: string
   }
}
export default class OnboardingService {
   static async getProgressStatuses() {
      const data = await apiGet<ResponseSuccess<IOnboardingProgress[]>>({
         apiPath: `onboarding-process-progress/organization-progress`,
      })
      return data.data
   }

   static async getProgress() {
      const data = await apiGet<ResponseSuccess<IProgressData[]>>({
         apiPath: `onboarding/sync-progress`,
      })
      return data.data
   }

   static async getOnboardingProgress() {
      const data = await apiGet<ResponseSuccess<IOrganizationDetails>>({
         apiPath: `/organization-account/details`,
      })
      return data.data
   }

   static async updateA2PRegistration(ein: string, legalBusinessName: string) {
      const data = await apiPatch<ResponseSuccess<object>>({
         apiPath: `/organization-account/a2p/ein`,
         data: {
            ein: ein,
            legalBusinessName: legalBusinessName,
         },
      })
      return data.data
   }

   static async uploadBrandLogo(formData: any) {
      const data = await apiPost<ResponseSuccess<IOrganizationDetails>>({
         apiPath: `/organization-account/upload-brand-logo`,
         data: formData,
         config: {
            headers: {
               'Content-Type': 'multipart/form-data',
            },
         },
      })
      return data.data
   }

   static async removeBrandLogo() {
      const data = await apiDelete({
         apiPath: `/organization-account/remove-brand-logo`,
      })
      return data
   }
}
